// extracted by mini-css-extract-plugin
export default {"modal-wrapper":"EditCategoryModal_modal-wrapper__EoHTF"};